import { queryOptions } from '@tanstack/react-query'
import { apiGet, apiPost, type PostValue } from './client'

/**
 * Alarmele proprii ale unui modul-sora (Securitee, Printeeng): capetele
 * `/settings/<modul>/alarms/*`, perechile vechi settings/<Modul>::get_alarms,
 * create_alarm, update_alarm, load_default_settings, change_alarm_status,
 * remove_alarm, checkAlarmValue, create_alarm_form, edit_alarm_form.
 */
export type ModuleAlarmsBase = '/settings/securitee' | '/settings/printeeng'

export type AlertType = { ID: number; type_name: string; dinamic: number; sign?: string; alert_type_description?: string }
export type AlarmRow = Record<string, unknown> & { triggers?: Array<{ event_action: string; trigger_name: string }> }
export type AlarmsList = { default: boolean; alertType: AlertType | null; alarms: AlarmRow[] }
export type AlarmCategory = { ID: number; category_name: string; alert_types: AlertType[] }

export function moduleAlarmsQuery(base: ModuleAlarmsBase) {
  return queryOptions({
    queryKey: ['settings', base, 'alarms'],
    queryFn: () => apiGet<{ categories: AlarmCategory[]; workstation?: boolean; door?: string }>(base + '/alarms'),
  })
}

export function moduleAlarmListQuery(base: ModuleAlarmsBase, type: number) {
  return queryOptions({
    queryKey: ['settings', base, 'alarms', 'type', type],
    queryFn: () => apiGet<AlarmsList>(base + '/alarms/type/' + type),
    enabled: type > 0,
  })
}

export function moduleAlarmCreateForm(base: ModuleAlarmsBase, type: number) {
  return apiGet<{ alarm: AlertType }>(base + '/alarms/create-form/' + type)
}

export function moduleAlarmEditForm(base: ModuleAlarmsBase, id: number) {
  return apiGet<{ alarm: AlarmRow; alarmType: AlertType | null; notifiers: Array<{ address: string }> }>(base + '/alarms/' + id + '/edit')
}

export function moduleAlarmCreate(base: ModuleAlarmsBase, fields: Record<string, PostValue>) {
  return apiPost<{ ok?: boolean; id?: number }>(base + '/alarms', fields)
}

export function moduleAlarmUpdate(base: ModuleAlarmsBase, fields: Record<string, PostValue>) {
  return apiPost<{ ok?: boolean }>(base + '/alarms/update', fields)
}

export function moduleAlarmLoadDefaults(base: ModuleAlarmsBase, type: number) {
  return apiPost<{ loaded?: number }>(base + '/alarms/defaults', { type })
}

export function moduleAlarmStatus(base: ModuleAlarmsBase, alarm: number, activate: number) {
  return apiPost<{ ok?: boolean }>(base + '/alarms/status', { alarm, activate })
}

export function moduleAlarmRemove(base: ModuleAlarmsBase, alarm: number) {
  return apiPost<{ ok?: boolean }>(base + '/alarms/remove', { alarm })
}

export function moduleAlarmCheckValue(base: ModuleAlarmsBase, fields: Record<string, PostValue>) {
  return apiPost<{ valid: 'true' | 'false' }>(base + '/alarms/check-value', fields)
}
